import * as React from "react";
import { forwardRef } from "react";
const SvgArrowDownSmall = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 15.98, height: 20.5, ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M19.75 7.512a1.265 1.265 0 0 0-.305-.775L13.433.35a1.293 1.293 0 0 0-1.644-.094A1.174 1.174 0 0 0 11.8 1.9l4.227 4.486h-14.9a1.127 1.127 0 1 0 0 2.254h14.9L11.8 13.125a1.241 1.241 0 0 0-.012 1.644 1.276 1.276 0 0 0 1.644-.094l6.012-6.388a1.089 1.089 0 0 0 .305-.775z", transform: "rotate(90 7.57 7.945)", style: {
  fill: "#006dc9",
  stroke: "#f5f5f5",
  strokeWidth: ".75px"
} }));
const ForwardRef = forwardRef(SvgArrowDownSmall);
export { ForwardRef as ReactComponent };
